/**
 * Attach Call Me event to links of class 'callMe'
 * (could be called from initOIDoc)
 */
function callMeButtonPopup() {
  // Bootstrap 5 vanilla JS: Add click event listener
  const callMeBtn = document.getElementById('callMe');

  if (callMeBtn) {
    callMeBtn.addEventListener('click', function (e) {
      const dialog = document.getElementById('popup_content');
      const xView = e.pageX - window.pageXOffset;
      const yView = e.pageY - window.pageYOffset;

      if (dialog) {
        dialog.innerHTML = $loading;
        fetch(this.getAttribute('href'))
          .then((response) => response.text())
          .then((html) => {
            dialog.innerHTML = html;
            const modal = new bootstrap.Modal(dialog, {
              backdrop: true,
              keyboard: true
            });
            modal.show();
          })
          .catch((error) => {
            console.error('Error loading Call Me content:', error);
          });
      }
    });
  }

  return false;
}
/**
 * convert the oi:gl tags to glossary links
 */
function convertToGlossaryLinks()
{
	//find any oi:gl or oi:ml tag and turn it into a glossary url
	//<oi:gl key="glo_prescription_drugs">Coverage for Prescription Drugs</oi:gl>
  //<oi:ml key="ede.add_person.help"><i class="fas fa-question-circle"></i> Learn more about who to include.</oi:ml>

  $('oi\\:gl').each(function () {
    var url = getContextPath() + '/eapp/glossarylookup?type=JSON&lookupTerm=' + $(this).attr('key');
    url += '&catalogId=' + oiConfig.catalogId + '&clientId=' + oiConfig.clientId;
    var content =
      '<a tabindex="0" class="iconGlossary" aria-label="Glossary Link" href="' + url + '">' + $(this).html() + '</a>';
    $(this).html(content);
  });

  convertOiMlToLinks();

    $("oi\\:ht").each(function() {
        var url = getContextPath()+"/eapp/messageresourcelookup?type=JSON&key="+$(this).attr('key');
		    var content = $('<a class="iconGlossary" aria-label="Learn More" href="'+url+'">'+$(this).html()+"</a>");
        
		    $(this).html(content);
    });
}

/**
 * load glossary links into popup model
 */
function initGlossaryLinks()
{
    convertToGlossaryLinks();
	//attach glossary event listener to every link that has the icon glossary glass	
	// Use event delegation so dynamically added .iconGlossary elements also get the handler
	$(document).off('click.glossaryLink', '.iconGlossary').on('click.glossaryLink', '.iconGlossary', function(e) {
		e.preventDefault();
		glossaryEventHandler(this);
		return false;
	});

}


function setGlossaryTitle(aPopOverLink){
   return aPopOverLink == null ? "Glossary" : $(aPopOverLink).attr("title");
}

function closeAllPopovers(excludeEl) {
    document.querySelectorAll('.iconGlossary, a[data-bs-title]').forEach(function(el) {
        if (el === excludeEl) return;

        const popover = bootstrap.Popover.getInstance(el);
        popover?.hide();
    });
}

function glossaryEventHandler(aPopOver) {
    // If popover already exists, toggle it (global listener handles closing others)
    const existingPopover = bootstrap.Popover.getInstance(aPopOver);
    if (existingPopover) {
        existingPopover.toggle();
        return;
    }

    // Get href from element
    let lHref = aPopOver.getAttribute("href");

    if (!lHref.includes("type=JSON")) {
        lHref += (lHref.includes("?") ? "&" : "?") + "type=JSON";
    }
    if (!lHref.includes("&clientId=")) {
        lHref += "&clientId=" + oiConfig.clientId;
    }

    fetch(lHref)
        .then(response => response.json())
        .then(data => {
            let title;
            let content;

            if (data.value) {
                const rId = aPopOver.getAttribute('data-responder-id');
                content = typeof replaceSurveyPlaceHolderContent === 'function'
                    ? replaceSurveyPlaceHolderContent(rId, data.value)
                    : data.value;
                title = aPopOver.innerHTML.replace(/<\/?oitext[^>]*>/gi, '');
            } else {
                title = data.term;
                content = data.definition;
            }

            title = title || '\u00A0'; // Use non-breaking space if title is empty to prevent Bootstrap from hiding the popover

            // Set attributes for Bootstrap 5
            aPopOver.setAttribute("data-bs-title", title);
            aPopOver.setAttribute("data-bs-content", content);
            aPopOver.setAttribute("data-bs-html", "true");

            // Create a Bootstrap 5 Popover instance
            const popover = new bootstrap.Popover(aPopOver, {
                trigger: "click",
                html: true
            });

            // Show the popover
            popover.show();
        })
        .catch(err => console.error("Error loading popover data:", err));
}

/**
 * called when the page renders
 */
function initOIDoc() {
  initGlossaryLinks();

  // Initialize MDB checkbox components for existing content
  // Set in shared-ui/mdb-helpers.js 
  initializeMDBComponentsForCheckboxes();
  initializeMDBComponentsForInputs();
  initializeSelects();
  initializeDatePickers();
  
  //Session inactivity timeout - shared-ui/js/timeout.js, bundled ahead of this file.
  //It owns the modal, countdown, "I'm Still Here" restart and excluded paths.
  initOITimeout({
    app: 'mgmnt',
    //server session-timeout is 13 minutes (web.xml): 10 minutes idle, then a 2:30 countdown
    //in the modal, so the logout POST lands while the session and its CSRF token still exist
    warningMs: 600000,
    countdownMs: 150000
  });

  callMeButtonPopup();
}

//IOS click fix
function onClickReplace() {
  (function ($) {
    $.fn.tclick = function (onclick) {
      this.bind('touchstart', function (e) {
        onclick.call(this, e);
        e.stopPropagation();
        e.preventDefault();
      });
      this.bind('click', function (e) {
        onclick.call(this, e);
      }); //substitute mousedown event for exact same result as touchstart
      return this;
    };
  })(jQuery);
}

/**
 * switch the locale when available
 */
function switchLocaleListener() {
  // Bootstrap 5 vanilla JS: Add click event listeners for locale switcher
  document.querySelectorAll('a.swithcLocale').forEach(function (element) {
    element.addEventListener('click', function () {
      const url = this.getAttribute('href');
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          location.reload();
        })
        .catch((error) => {
          console.error('Error switching locale:', error);
        });
      return false;
    });
  });
}

var $loading = '<img src="' + getContextPath() + '/images/loader.gif" alt="loading" />';

// Bootstrap 5 vanilla JS: Document ready replacement
onDocumentReady(function () {
  initOIDoc();
  switchLocaleListener();
  onClickReplace();
  applyCommonInputMasks();

  // Close popovers when clicking outside or when clicking a different glossary link
  document.addEventListener('click', function(e) {
    var clickedGlossary = e.target.closest('.iconGlossary, a[data-bs-title]');
    if (!e.target.closest('.popover')) {
      closeAllPopovers(clickedGlossary);
    }
  });

  //why do we need this?
  // Bootstrap 5 vanilla JS: Add click event listeners for back buttons
  document.querySelectorAll('a.back').forEach(function (element) {
    element.addEventListener('click', function () {
      parent.history.back();
      return false;
    });
  });
});

// Using this over $(".datePickerBasic").daterangepicker so that it will work with dynamically added elements
$('body').on('focus',".datePickerBasic", function(){
	if ($(this).is('[readonly]')) {
		return;
	}
	$(this).daterangepicker({
		autoUpdateInput: false, //Don't pre-fill with a default before date selection
		autoApply: true,
		singleDatePicker: true,
		showDropdowns: true,
		minYear: 1901,
		maxYear: 2099,
		drops: 'auto'
	});
});
// Have to manually update on date selection when autoUpdateInput is off
$('body').on('apply.daterangepicker',".datePickerBasic", function(ev, picker){
	var $input = findInput($(this));
	$input.val(picker.startDate.format('MM/DD/YYYY'));
	$input.change(); // Fixes bootstrap material design floating label not floating
});
$('body').on('cancel.daterangepicker',".datePickerBasic", function(ev, picker){
	findInput($(this)).val('');
});
function findInput($that) {
  if ($that.prop('nodeName') == 'INPUT') {
    var $input = $that;
  } else {
    var $input = $that.closest('.input-group').find('.dateInput');
  }
  if (typeof $input === 'undefined' || $input.prop('nodeName') !== 'INPUT') {
    $input = $that.closest('.input-group').find('input.date');
  }
  return $input;
}

$('.selectpicker').selectpicker({
    style: '',
    noneSelectedText: 'Any',
    dropupAuto: false,
    actionsBox: true,
    liveSearch: true,
    width: "80%",
    size: 5
});
$('.selectpickerslim').selectpicker({
    style: '',
    noneSelectedText: 'Any',
    dropupAuto: false,
    actionsBox: false,
    liveSearch: false,
    width: "80%",
    size: 5
});
// Bootstrap 5 vanilla JS: Update button classes
document.querySelectorAll('.actions-btn').forEach(function (button) {
  button.classList.remove('btn-light');
});

function changeButtonToSpinner(aButton) {
  // disable button
  aButton.prop('disabled', true);
  // disable click event listeners
  aButton.css('pointer-events', 'none');
  // add spinner to button
  aButton.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading...');
}

function changeLinkToSpinner(aLink) {
  // disable button
  aLink.addClass('disabled');
  // add spinner to button
  aLink.html(aLink.html() + ' <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
}
